import React from 'react';
import { ModalTitle } from '../../global/Styles/titles';
import { Field, Form } from 'react-final-form';
import FormStateToRedux from '../RFF/FormStateToRedux';

import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import { inputsSettingsFalse, inputsSettingsTrue } from '../../global/Styles/inputs';
import { ButtonTable } from '../../global/Styles/buttons';
import { store } from '../../../store';

const ModalCrearLugar = (props) => {
  const storeState = store.getState();

  const handleSubmit = (e) => {
    e.preventDefault();
    // ...lógica para crear el nuevo lugar...
    props.onClose();
  };

  //   console.log('storeState.Lugar: ', storeState.lugar?.selLugar);
  const editMode = storeState.lugar?.selLugar === null ? false : true;

  console.log('editMode: ', editMode);

  const { postLugar, putLugar } = props.endPoint;
  const { filterContrato } = props.data;

  const proxyTask = (values) => {
    // ...lógica para crear el nuevo lugar...

    const withContrato = {
      ...values,
      CONTRATO_ID: filterContrato,
    };

    if (editMode) {
      putLugar(withContrato);
      return;
    }

    postLugar(withContrato);
  };

  const { municipioOptions } = props.data;

  const validate = (values) => {
    const errors = {};

    if (!values.MUNICIPIO_ID) {
      errors.MUNICIPIO_ID = 'Este campo es requerido';
    }

    if (!values.LUGAR_DESCRIPCION) {
      errors.LUGAR_DESCRIPCION = 'Este campo es requerido';
    }

    return errors;
  };

  const setMUNICIPIO_ID = (args, state, { setIn, changeValue }) => {
    const field = state.fields['MUNICIPIO_ID'];

    field.change(args[0].value);
    state.formState.submitFailed = true;
  };

  return (
    <div
      className="min-w-screen animated fadeIn faster outline-none  focus:outline-none  fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-scroll bg-cover bg-center bg-no-repeat"
      id="modal-id">
      <div className="fixed inset-0 z-0 bg-black opacity-50"></div>
      <div className="relative mx-auto my-auto w-full max-w-2xl rounded-xl bg-white p-5  shadow-lg ">
        <ModalTitle>{editMode ? 'EDITAR' : 'NUEVO'} LUGAR</ModalTitle>

        <Form
          onSubmit={proxyTask}
          validate={validate}
          initialValues={editMode ? { ...storeState.lugar.selLugar } : {}}
          subscription={{ submitting: true, pristine: true }}
          mutators={{
            setMUNICIPIO_ID,
          }}>
          {({ handleSubmit, form, submitting, pristine }) => (
            <form onSubmit={handleSubmit}>
              <div className="">
                <div className="flex-auto justify-center p-5 text-left">
                  <FormStateToRedux form="frmAgregarLugar" />
                  <div className="mt-1 flex  flex-col">
                    <p className="text-sm text-gray-800">Municipio DIAN</p>
                    {municipioOptions.length > 0 ? (
                      <Field name="MUNICIPIO_ID">
                        {({ input, meta }) => (
                          <>
                            <Select
                              options={municipioOptions}
                              defaultValue={input.value ? municipioOptions.find((option) => option.value === input.value) : null}
                              name="selectMunicipio"
                              onChange={form.mutators.setMUNICIPIO_ID}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  marginTop: 6,
                                  borderColor: meta.error && meta.touched ? 'red' : null,
                                }),
                              }}
                            />

                            <input
                              {...input}
                              type="hidden"
                            />
                          </>
                        )}
                      </Field>
                    ) : (
                      <div className="mt-1 flex-grow pb-1">
                        <Skeleton
                          height={34}
                          width="100%"
                        />
                      </div>
                    )}
                  </div>
                  <Field name="LUGAR_DESCRIPCION">
                    {({ input, meta }) => (
                      <>
                        <p className="text-sm text-gray-800">Nombre</p>
                        <input
                          {...input}
                          type="text"
                          placeholder="nombre"
                          className={meta.error && meta.touched ? `${inputsSettingsFalse}` : `${inputsSettingsTrue}`}
                        />
                        {/* PENDIENTE PARA AGREGAR TOOLTIPS CON LOS ERRORES */}
                      </>
                    )}
                  </Field>
                </div>
                <div className="md:block mx-16 mt-2 space-x-4 text-center">
                  <ButtonTable onClick={() => props.onClose()}>Cancelar</ButtonTable>
                  <ButtonTable
                    type="submit"
                    disabled={submitting || pristine}>
                    Agregar
                  </ButtonTable>
                </div>
              </div>
            </form>
          )}
        </Form>
      </div>
    </div>
  );
};

export default ModalCrearLugar;
